import SubscriptionContainer from './components/SubscriptionContainer';

const ClassicCheckoutApp = () => {	
	return (
		<div className="wds-subscription-app wds-subscription-app--classic-checkout">
			<SubscriptionContainer />
		</div>
	);
};

export default ClassicCheckoutApp;